module.exports = "/assets/landing-rc/cuisines/60.jpg?iJFz0/r";